import { EventMeta } from '../../../interfaces/meta.interface';

const hardDelete: EventMeta = {
    title: 'Message Purged',
    default: {
        description: 'Message Purged',
        longDescription: 'A message was purged from the Recoverable Items folder (permanently deleted).',
        severity: 'info',
    },
};

export default hardDelete;
